'use client';

import { useEffect } from 'react';
import catchError from '@/lib/utils/catchError';

const KlaviyoFormHandler = () => {
  const handleKlaviyoForm = (e) => {
    try {
      setTimeout(() => {
        if (e?.detail?.type === 'submit') {
          if (document) {
            const donotsellBlock = document.querySelector('.donotsell-block .klaviyo-form');

            // handle donot sell form submit
            if (donotsellBlock) {
              window.updateCustomerDnsFlag();
            }
          }
        }
      }, 2000);
    } catch (error) {
      catchError('handleKlaviyoForm error: ', error);
    }
  };

  useEffect(() => {
    window?.addEventListener('klaviyoForms', handleKlaviyoForm);

    return () => {
      window?.removeEventListener('klaviyoForms', handleKlaviyoForm);
    };
  }, []);

  return null;
};

export default KlaviyoFormHandler;
